export interface HistoryByStateData {
    clientId: string;
    entityId: string;
    clientTaxPeriodId: number;
    jurisdiction: string;
    clientName: string;
    entityName: string;
    taxDue: number;
    currentSalesRawData: number;
    totalSalesTaxReturnCurrentMonth: number;
    salesTax: number;
    useTax: number;
    currentPurchases: number;
    discounts: number;
    boAndExcise: number;
    prepayments: number;
    prepayCredit: number;
    carryForwardAmount: number;
    totalSalesRawData: number;
    totalSalesTaxReturn: number;
    totalPurchasesRawData: number;
    totalPurchasesTaxReturn: number;
    year: number;
    month: number;
  }
  